import { render, staticRenderFns } from "./announcement.vue?vue&type=template&id=4476f8ec&scoped=true&"
import script from "./scripts.js?vue&type=script&lang=js&"
export * from "./scripts.js?vue&type=script&lang=js&"
import style0 from "./announcement.vue?vue&type=style&index=0&id=4476f8ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4476f8ec",
  null
  
)

export default component.exports